
import { Component, Vue, Watch } from "vue-property-decorator";
import vNavigation from "@/components/vNavigation.vue";
import vHeader from "@/components/vHeader.vue";
import vFooter from "@/components/vFooter.vue";
import { LOGOUT_USER } from "@/store/ActionTypes";
import { mapState } from "vuex";
import VTooltip from "@/components/v-tooltip";
import { AddOnType } from "@/models/Subscriptions/AddOns/AddOnType";
import {AccountState} from "@/store/modules/AccountModule";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import VUpsellModal from "@/components/modals/marketing/vUpsellModal.vue";
import systemRepository from "@/utils/API/SystemRepository";
Vue.use(VTooltip, {
  defaultTemplate:
    "<div class='tooltip-vue' role='tooltip'><div class='tooltip-vue-inner'></div></div>",
  defaultInnerSelector: ".tooltip-vue-inner",
});

@Component({
  components: {
    VUpsellModal,
    vNavigation,
    vHeader,
    vFooter,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
class User extends Vue {
  navigationOpen = false;
  headerOpen = false;
  localizationState: LocalizationState;
  accountState: AccountState;
  currentBuildId: string | null = null;
  bannerText: string = "";
  pollTimer: number | null = null;

  showTrialUpsellModal: boolean = false;
  defaultTrialUpsellMessage: string = "This feature requires a paid subscription to use.";
  trialUpsellMessage: string = this.defaultTrialUpsellMessage;

  openTrialUpsellModal(message: string = this.defaultTrialUpsellMessage) {
    this.trialUpsellMessage = message;
    this.showTrialUpsellModal = true;
  }
  closeTrialUpsellModal() {
    this.showTrialUpsellModal = false;
    this.trialUpsellMessage = this.defaultTrialUpsellMessage;
  }

  closeMobile() {
    if (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    ) {
      this.closeNavigation();
    }
  }

  // Show recipe cost link, check if user paid for recipe cost
  showRecipeCostLink() {
    if (this.accountState.userDetails.addOns) {
      return this.accountState.userDetails.addOns
        .map((x: any) => x.addOn)
        .includes(AddOnType.RecipeCost);
    }
    return false;
  }

  showWellnessLink() {
    if (this.accountState.userDetails.isTrial) {
      return true;
    }

    if (this.accountState.userDetails.addOns) {
      return this.accountState.userDetails.addOns
        .map((x: any) => x.addOn)
        .includes(AddOnType.WellnessModule);
    }
    return false;
  }

  logout() {
    this.$store.dispatch(LOGOUT_USER);
  }

  toggleNavigation() {
    if (this.navigationOpen) {
      this.closeNavigation();
    }
    else {
      this.openNavigation();
    }
  }

  openNavigation() {
    this.navigationOpen = true;
  }

  closeNavigation() {
    this.navigationOpen = false;
  }

  toggleHeaderMenu() {
    this.headerOpen = !this.headerOpen;
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    let language: string = this.$store.getters.getUserDetails.localization;
    language = language.substring(0, 2);

    if (this.$validator.dictionary.hasLocale(language)) {
      this.$validator.localize(language);
    }
    else {
      import(`vee-validate/dist/locale/${language}`).then((locale) => {
        this.$validator.localize(language, locale);
      });
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    let onbloardFlowLoader = (<any>window).onboardFlowLoader;
    if (onbloardFlowLoader && (<any>window).onboardFlowSettings) {
      onbloardFlowLoader.identify((<any>window).onboardFlowSettings);
    }
  }

  mounted() {
    Vue.nextTick(() => {
      // @ts-ignore
      $.Pages.initSidebar();
    });

    // poll immediately on load
    this.pollVersion();

    // start interval for every 10 minutes (600,000 ms)
    this.pollTimer = window.setInterval(() => {
      this.pollVersion();
    }, 600000);
  }

  async pollVersion() {
    try {
      const { data } = await systemRepository.getBuildVersion();
      this.bannerText = data.message || "";
    }
    catch (err) {
      console.warn("Version poll failed", err);
    }
  }

  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }
}
export default User;
